import React from 'react';
import {useSelector} from 'react-redux';
import {useChatWithUserPathname} from '../../../../../data/hooks/chat/useChatWithUserPathname';
import {useI18n} from '../../../../../data/hooks/i18nHooks';
import ButtonLink from '../../../../elements/ButtonLink';

const ChatButton = props => {
    const {event, question, answer} = props,
        i18n = useI18n(),
        user = useSelector(state => state.users[answer.answerer_id]),
        chatPathname = useChatWithUserPathname(user.user_id ?? user.id);

    if (!user) return null;

    return (
        <ButtonLink
            type="button"
            className="buttonlink smallButton marginTop marginRight"
            href={chatPathname}
            style={{
                ...event._local.styles.smallButton,
                width: 'auto',
                display: 'inline-block',
            }}>
            {i18n['label.chat']}
        </ButtonLink>
    );
};

export default ChatButton;
